import { Row, Container } from 'react-bootstrap';
import { content } from '../../EditPanel/Galeria/Itens/props'
import { Html } from '../../Component/Commons';
export function Galeria({ data: { props, itens } }: any) {
    const { color, width, gap } = props;
    return <Row className='m-0 p-0' style={{ backgroundColor: color }}>
        <Container style={{
            display: 'grid', gap,
            gridAutoFlow: 'dense',
            gridAutoRows: `repeat(auto-fill,minmax(${width}px, 1fr))`,
            gridTemplateColumns: `repeat(auto-fill, minmax(${width}px, 1fr))`,
        }}>
            {itens.map((i: any) => <Itens key={'itens' + i.id} iten={i} config={props} />)}
        </Container>
    </Row>
}
function Itens({ config: { animated, width }, click,
    iten: { html, props: { img, col, row, margin, color, back, id } } }: any) {
    return <div style={{
        minHeight: `${width}px`, minWidth: `${width}px`,
        gridRow: `span ${row}`, gridColumn: `span ${col}`
    }} onClick={() => click()} className={content(back, color, margin, animated, col, row, false)}>
        <img style={{ display: 'block', width: '100%' }} alt="Bricks"
            src={(width < 300) ? img.replace('ver', 'short') : img} />
        <Html style={{
            background: `${back}`, color: `${color}`,
            margin: `${margin}px ${margin}px ${margin}px ${margin}px`
        }} className="caption" html={html} />
    </div>
}